import Config from '../data/Config'
import { apiClient } from '../infra/http/apiClient'

// Keep mock data for development/testing
const mockAuthData = {
  token:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjExIiwiZW1haWwiOiJhZG1pbkBleGFtcGxlLmNvbSIsInJvbGUiOiJBRE1JTiIsImlhdCI6MTczNzAwNzcyNSwiZXhwIjoxNzM3MDk0MTI1fQ.PHukZ8WCSL7ksGqd-wFxHLTBcxFyWHjIJkvKVGQcmfQ',
  user: {
    resourceId: '11',
    email: 'admin@example.com',
    firstName: 'Test',
    lastName: 'User',
    roles: ['ADMIN'],
    createdAt: new Date().toISOString(),
    sports: ['SKI', 'SNOWBOARD'],
    instructorCertificates: ['CASI L88'],
    certificateVerified: true,
    bio: 'I am a ski instructor at Mont Cascades',
    avatar: '/static/images/avatar/1.jpg',
    clubMembershipId: 'SKI2024001',
  },
  expiresIn: 3600,
}

class AuthService {
  async login(email, password) {
    try {
      // Use real API in production, mock in development
      if (Config.IS_DEV && (email === 'admin@example.com' || email === 'user@example.com')) {
        return mockAuthData
      }

      const response = await apiClient.post('/auth/login', {
        email,
        password,
      })

      return response.data
    } catch (error) {
      console.error('Login failed:', error)
      throw error
    }
  }

  async logout() {
    try {
      await apiClient.post('/auth/logout')
    } catch (error) {
      console.error('Logout error:', error)
      throw error
    }
  }

  async signup(signupData) {
    try {
      const response = await apiClient.post('/users', {
        email: signupData.email,
        password: signupData.password,
        firstName: signupData.firstName,
        lastName: signupData.lastName,
        sports: signupData.sports,
      })

      return response.data
    } catch (error) {
      console.error('Signup failed:', error)
      throw error
    }
  }

  async authGoogle(tokenResponse) {
    try {
      const response = await apiClient.post('/auth/google', { credential: tokenResponse.access_token })
      return response.data
    } catch (error) {
      console.error('Google authentication failed:', error)
      throw new Error('Failed to authenticate with Google')
    }
  }

  // TODO RESET PASSWORD also should use this function
  async updatePassword({ currentPassword, newPassword, resetToken, token }) {
    try {
      let endpoint = '/auth/update-password'
      let payload = {}

      if (resetToken) {
        // Reset with token
        payload = {
          resetToken,
          newPassword,
        }
      } else if (currentPassword && token) {
        // Reset with current password
        payload = {
          currentPassword,
          newPassword,
        }
      } else {
        throw new Error('Either currentPassword and token or resetToken must be provided')
      }

      const response = await apiClient.post(endpoint, payload)
      return response.data
    } catch (error) {
      console.error('Password update failed:', error)
      throw error
    }
  }

  async forgetPassword(resetEmail) {
    try {
      const response = await apiClient.post('/auth/forget-password', { email: resetEmail })
      return response.data
    } catch (error) {
      console.error("Can't submit reset password request:", error)
      throw error
    }
  }
}

export default new AuthService()
